import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IFileInfo } from 'src/app/models/i-file-info.interface';
import { IUploadInputEvent } from 'src/app/models/iupdload-event.interface';
import { AbstractService } from 'src/app/services/data/abstract.service';
import { ABSTRACT_STATUS_ENUM, HTTP_CONTENT_HEADERS } from '../../data/const.data';
import * as saveAs from 'file-saver';
import { ConfirmationService } from 'primeng/api';

@UntilDestroy()
@Component({
  selector: 'app-upload-poster-pdf',
  templateUrl: './upload-poster-pdf.component.html',
  styleUrls: ['./upload-poster-pdf.component.css'],
})
export class UploadPosterPdfComponent implements OnInit, OnChanges {
  // tslint:disable:no-inferrable-types
  readonly allowedStatuses: string[] = [
    ABSTRACT_STATUS_ENUM.ACCEPTED,
  ];

  @Input() confId: number = 0;
  @Input() abstractId: string = '';
  @Input() posterPath: string = '';
  @Input() status: string = '';
  isLoadComponent: boolean = false;
  isDeleteBtn: boolean = false;
  isDownloadBtn: boolean = false;
  isDisableUploadBtn: boolean = true;

  @Output() ReloadPage = new EventEmitter<boolean>();

  posterFileName: string = '';
  readonly noFileMessage: string = 'Файл не выбран.';

  inputFile: File = null;

  fileInfo: IFileInfo = null;

  pdfSrcView: string = '';


  $loadFileInfoTable: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  constructor(
    private srv: AbstractService,
    private _confirm: ConfirmationService,
  ) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.onCheckInputData();
  }

  ngOnInit(): void {
    this.onCheckInputData();
  }

  onCheckInputData() {
    this.inputFile = null;
    this.fileInfo = null;
    this.isDisableUploadBtn = true;

    if (
      (this.abstractId === null || this.abstractId === undefined) ||
      (this.confId === null || this.confId === undefined) ||
      (this.status === null || this.status === undefined)
    ) { return; }

    this.posterPath = this.posterPath !== null && this.posterPath !== undefined ? this.posterPath : '';

    const cond = this.allowedStatuses.includes(this.status);
    if (!cond) { return; }

    this.isLoadComponent = true;

    if (this.status === ABSTRACT_STATUS_ENUM.ACCEPTED) {
      this.isDeleteBtn = false;
      this.isDownloadBtn = false;
      this.$loadFileInfoTable.next(false);
    }

    if (this.posterPath !== '') {
      this.srv.getAbstractPoster(this.confId, this.abstractId)
      .pipe(
        untilDestroyed(this),
        tap(file => {
          this.fileInfo = this.getFileInfo(file);
          const reader = new FileReader();
          reader.onloadend = () => {
            this.pdfSrcView = reader.result as string;
          };
          reader.readAsDataURL(file);
        })
      ).subscribe();

    // this.srv.downloadAbstractPoster(this.confId, this.abstractId);
      this.$loadFileInfoTable.next(true);
      this.isDeleteBtn = true;
      this.isDownloadBtn = true;
    }

    // switch (this.status) {
    //   case ABSTRACT_STATUS_ENUM.ACCEPTED:
    //     this.isDeleteBtn = false;
    //     this.isDownloadBtn = false;
    //     this.$loadFileInfoTable.next(false);
    //     break;
    //   // import { PdfViewerModule } from 'ng2-pdf-viewer';
    //   case ABSTRACT_STATUS_ENUM.POSTER_UPLOADED:
    //     this.srv.getAbstractPoster(this.confId, this.abstractId)
    //       .pipe(
    //         untilDestroyed(this),
    //         tap(file => {
    //           this.fileInfo = this.getFileInfo(file);
    //           const reader = new FileReader();
    //           reader.onloadend = () => {
    //             this.pdfSrcView = reader.result as string;
    //           };
    //           reader.readAsDataURL(file);
    //         })
    //       ).subscribe();

    //     // this.srv.downloadAbstractPoster(this.confId, this.abstractId);
    //     this.$loadFileInfoTable.next(true);
    //     this.isDeleteBtn = true;
    //     this.isDownloadBtn = true;
    //     break;

    //   case ABSTRACT_STATUS_ENUM.POSTER_INVALID:
    //     this.isDeleteBtn = true;
    //     this.isDownloadBtn = false;
    //     break;
    // }
  }

  onSelectFile(event: any) {
    const file = (event as IUploadInputEvent).target.files[0];

    if (file.type !== 'application/pdf') {
      // TODO: Make norm alert
      alert('File is not pdf!');
      return;
    }

    this.inputFile = file;

    // file.type
    // console.log(file);

    this.fileInfo = this.getFileInfo(this.inputFile);
    this.isDisableUploadBtn = false;

    // this.$fileInfoObservable.next(info);
    this.$loadFileInfoTable.next(true);
    this.onUploadFile();

    // console.log(this.$loadFileInfoTable);

    // this.onGetFileInfoTest(this.inputFile);

    // this.messageService.add({severity: 'info', summary: 'File Uploaded', detail: ''});
  }


  getFileInfo(file: File): IFileInfo {
    // tslint:disable-next-line:curly
    if (file === null || file === undefined) return null;

    let fileSizeFormatted: string;
    const fileSizeInMB = file.size / (1024 * 1024); // переводим размер из байт в мегабайты

    if (fileSizeInMB < 1) {
      // Если размер файла меньше мегабайта, отображаем в килобайтах
      const fileSizeInKB = file.size / 1024;
      fileSizeFormatted = fileSizeInKB.toFixed(2) + ' KB'; // округляем до двух знаков после запятой и добавляем единицу измерения
    } else {
      // Иначе отображаем в мегабайтах
      fileSizeFormatted = fileSizeInMB.toFixed(2) + ' MB'; // округляем до двух знаков после запятой и добавляем единицу измерения
    }

    // Преобразование даты последнего изменения в формат yyyy-MM-dd HH:mm
    const lastModifiedDate = new Date(file.lastModified);

    // tslint:disable-next-line:max-line-length
    const lastModifiedDateFormatted = lastModifiedDate.toISOString().replace(/T/, ' ').replace(/\..+/, ''); // форматируем дату как "yyyy-MM-dd HH:mm"

    return {
      name: file.name,
      size: fileSizeFormatted,
      lastModified: lastModifiedDateFormatted
    };
  }

  onUploadFile() {
    this.srv.sendAbstractPoster(this.confId, this.abstractId, this.inputFile)
      .pipe(
        untilDestroyed(this),
        tap(res => {
          // console.log(res);
          this.ReloadPage.emit(true);
        })
      ).subscribe(
      // res => { },
      // err => {
      //   console.log(err);
      //   this.onCheckInputData();
      // },
      // () => { console.log('LOAD COMPLETE'); this.onCheckInputData(); }
    );
  }

  onDeletePoster() {
    this._confirm.confirm({
      message: `Вы действительно хотите удалить постер?`,
      accept: () => {
        this.srv.deleteAbstractPoster(this.confId, this.abstractId)
          .pipe(
            untilDestroyed(this),
            tap(res => {
              console.log(res);
              this.ReloadPage.emit(true);
            }
            )
          ).subscribe();
      },
      reject: () => { }
    });


  }

  onDownloadPoster() {
    this.srv.downloadAbstractPoster(this.confId, this.abstractId)
      .pipe(
        untilDestroyed(this),
        tap((response) => {
          const file = new Blob([response.body], { type: HTTP_CONTENT_HEADERS.Pdf });
          const fileName = `poster-${this.confId}_${this.abstractId}.pdf`;
          saveAs(file, fileName);
        })
      ).subscribe();
  }

}
